import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { Registration } from '../types/registration';

type RegistrationsState = {
  records: Registration[];
  add: (registration: Registration) => void;
  getById: (id: string) => Registration | undefined;
  getByOwner: (email: string) => Registration[];
  clear: () => void;
};

export const useRegistrationsStore = create<RegistrationsState>()(
  persist(
    (set, get) => ({
      records: [],

      add(registration) {
        set((state) => ({ records: [registration, ...state.records] }));
      },

      getById(id) {
        return get().records.find((r) => r.id === id);
      },

      getByOwner(email) {
        return get().records.filter((r) => r.ownerEmail === email);
      },

      clear() {
        set({ records: [] });
      },
    }),
    {
      name: 'tt:registrations',
      version: 1,
      onRehydrateStorage: () => (state, error) => {
        if (error) {
          console.warn('Falha ao rehidratar tt:registrations — limpando.', error);
          try {
            localStorage.removeItem('tt:registrations');
          } catch {
            // ignore
          }
        }
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        state;
      },
    },
  ),
);
